import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

/**
 * "Ver como" el owner de una academia (PLATFORM_ADMIN, estilo Evazard).
 * El backend emite un access token del owner sin tocar la cookie de refresh
 * del staff — el consumidor de este hook debe pasar la respuesta a
 * `startImpersonation(access, company)` de useAuth(), no a `login()`.
 */
function useImpersonateCompany() {
  return useMutation({
    mutationFn: (companyId) =>
      apiClient
        .post(`/api/v1/superadmin/companies/${companyId}/impersonate/`)
        .then((r) => r.data),
  });
}

export { useImpersonateCompany };
